import React from "react";
import { DynamicButton, StyledText } from "../../../../components/common";
import { CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import styled from "styled-components";
import SmileImoji from "../../../../components/images/smile_imoji.png";
// import NoticeImg from "../../../../components/images/noticeImg.png";

const notification = {
  title: "💭 Got a Thought?",
  message:
    "Spotted something cool or curious? Share your take — or see what everyone’s buzzing about.",
};

const NewNotificationModal = ({ isOpen, onClose, viewNotifications }) => {
  const { themeContext, theme } = useTheme();

  if (!isOpen) return null;

  const dismissNotifications = () => {
    onClose(false);
  };

  return (
    <>
      <ModalOverlay onClick={() => {}} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            position: "relative",
            width: "100%",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 50,
              height: 8,
              backgroundColor: "#cbcbcb",
              borderRadius: 10,
              position: "absolute",
              top: "-5px",
              left: "0%",
              right: "0%",
              margin: "0 auto",
            }}
            onClick={() => {}}
          />
          <Header>
            <CloseButton onClick={dismissNotifications}>
              <CloseIcon width={18} />
            </CloseButton>
          </Header>

          <StyledText style={{ fontSize: 24, marginTop: 0 }}>
            {notification.title}
          </StyledText>
          <div style={{ maxWidth: "300px", margin: "0 auto" }}>
            <IconContainer>
              {/* <BellIcon /> */}
              {/* <PeerTalkIcons /> */}
              <img src={SmileImoji} alt="feeling" />
            </IconContainer>
            <StyledText
              style={{
                textAlign: "center",
                fontFamily: "MTNRegular",
                fontSize: "16px",
                margin: "0 0 20px 0",
              }}
            >
              {notification.message}
            </StyledText>

            <DynamicButton
              color="#FFCC00"
              textColor="#000"
              label="Join the Conversation"
              fullWidth
              onClick={viewNotifications}
              style={{ marginBottom: "10px" }}
            />
            <DynamicButton
              color="#000"
              textColor="#000"
              label="Dismiss"
              variant="outlined"
              fullWidth
              onClick={dismissNotifications}
            />
          </div>
        </div>
      </ModalContent>
    </>
  );
};

export default NewNotificationModal;

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  img {
    width: 90px;
    height: 100%;
  }
`;
